// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2sY7x","error":"Textarea_error__2wFm8","readonly":"Textarea_readonly__1d3i1","disabled":"Textarea_disabled__2prqY"};